import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {first, take} from "rxjs/operators";
import {Contract} from "../interface/contract";
import {ListResponse} from "../interface/response/list-response";
import {Registration} from "../interface/registration";
import {Ofwca} from "../interface/ofwca";
import {Support} from "../interface/support";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private readonly supportListSubject: ReplaySubject<CountedAndPaginated<Support>> = new ReplaySubject<CountedAndPaginated<Support>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }

  public loadList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<Support>>): void {
    this.httpClient.get(`/rest/crm/support?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Support>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.supportListSubject.next(result);
        }
      });
  }
  public getSupportListSubject(): ReplaySubject<CountedAndPaginated<Support>> {
    return this.supportListSubject;
  }
  public getOfwcaContract(ofwcaId: string): Observable<ListResponse<Contract>> {
    return this.httpClient.get(`/rest/crm/support/ofwca/${ofwcaId}/contractInfo`)
      .pipe(first()) as Observable<ListResponse<Contract>>;
  }
  public getPartnerContract(partnerId: string): Observable<ListResponse<Contract>> {
    return this.httpClient.get(`/rest/crm/support/partner/${partnerId}/contractInfo`)
      .pipe(first()) as Observable<ListResponse<Contract>>;
  }
  public getOfwcaRegistrations(ofwcaId: string): Observable<ListResponse<Registration>> {
    return this.httpClient.get(`/rest/crm/support/ofwca/${ofwcaId}/registrationInfo`)
      .pipe(first()) as Observable<ListResponse<Registration>>;
  }
  public getPartnerOfwca(partnerId: string): Observable<ListResponse<Ofwca>> {
    return this.httpClient.get(`/rest/crm/support/partner/${partnerId}/ofwcaInfo`)
      .pipe(first()) as Observable<ListResponse<Ofwca>>;
  }
  public sendForm(formData: object, supportId?: string): Observable<any> {
    if (!supportId) {
      return this.httpClient.post('/rest/crm/support', formData)
        .pipe(take(1))
        ;
    } else {
      return this.httpClient.put(`/rest/crm/support/${supportId}`, formData)
        .pipe(take(1))
        ;
    }
  }
  public get(supportId: string): Observable<Support> {
    return this.httpClient.get(`/rest/crm/support/${supportId}`)
      .pipe(first()) as Observable<Support>;
  }
  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/support/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
